// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__-cto7","navContainer":"Navigation_navContainer__+dgHg","itemName":"Navigation_itemName__mCq79"};